export class Contact {
    public body: string;
    public email: string;
    public name: string;

    constructor(data?: Partial<Contact>) {
        Object.assign(this, data);
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/contact/contact.ts